import axios from '@axios'

export default {
  getShopeeVouchers(params) {
    return axios.get('/api/shopee-vouchers', { params })
  },
}
